import { render, staticRenderFns } from "./CreateInsert.vue?vue&type=template&id=301af72b&scoped=true&"
import script from "./CreateInsert.vue?vue&type=script&lang=ts&"
export * from "./CreateInsert.vue?vue&type=script&lang=ts&"
import style0 from "./CreateInsert.vue?vue&type=style&index=0&id=301af72b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301af72b",
  null
  
)

export default component.exports